export default __webpack_public_path__ + "media/images/borders/brown-medium-border-70415d60015448c28dacdc110847d832.svg";